import { AlertsFeaturesAlertAlertFrequentie as Frequentie } from '@services/alerts-public/orval-api/model/alertsFeaturesAlertAlertFrequentie';
import { AlertsFeaturesAlertPolisTypeOntvanger as Ontvanger } from '@services/alerts-public/orval-api/model/alertsFeaturesAlertPolisTypeOntvanger';
import { type InputOption, type LabelValuePair } from '@shared/form/types';
import { type Alert } from './types';

export const frequentieOptions: InputOption<Frequentie>[] = [
  { label: 'Halfjaarlijks', value: Frequentie.HalfJaarlijks },
  { label: 'Jaarlijks', value: Frequentie.Jaar },
  { label: 'Tweejaarlijks', value: Frequentie.TweeJaar },
  { label: 'Driejaarlijks', value: Frequentie.DrieJaar },
];

export const ontvangerOptions: LabelValuePair<string>[] = [
  { label: Ontvanger.Adviseur, value: Ontvanger.Adviseur },
  { label: Ontvanger.Relatie, value: Ontvanger.Relatie },
];

export function getLabelByFrequentie(frequentie: Frequentie): string | undefined {
  const found = frequentieOptions.find((option) => option.value === frequentie);
  return found?.label ?? undefined;
}

export const defaultAlert = (): Alert => ({
  ontvangers: [],
  frequentie: Frequentie.Jaar,
  ingangsdatum: new Date(Date.now()),
  inhoud: '',
  ingangsdatumGelijkAanPolis: false,
});
